import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  theme => ({
    searchWrap: {
      position: 'relative',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    searchBox: {
      opacity: 1,
      backgroundColor: theme.colors.gray1,
      borderRadius: theme.borderRadius.min,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      width: '300px',
      minWidth: '300px',
      zIndex: 3,
      marginTop: '4px',
    },
    inputContainer: {
      padding: '12px',
      position: 'relative',
      width: '100%',
    },
    searchInput: {
      border: '1px solid rgba(0,0,0,.15)',
      borderRadius: theme.borderRadius.min,
      color: '#4c4c4c',
      fontSize: '14px',
      height: '32px',
      lineHeight: '22px',
      margin: '0',
      outline: 0,
      padding: '5px 22px 5px 8px',
      width: '100%',
      appearance: 'none',
      '&::placeholder': {
        fontSize: '14px',
        color: 'rgba(0,0,0,.15)',
      },
    },
    searchIcon: {
      color: 'rgba(0,0,0,.25)',
      position: 'absolute',
      right: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      fontStyle: 'normal',
      lineHeight: '0',
      textAlign: 'center',
      marginRight: '8px',
    },
    listBox: {
      listStyle: 'none',
      height: '192px',
      width: '100%',
      margin: 0,
      padding: 0,
      overflowY: 'auto',
    },
    optionList: {
      cursor: 'pointer',
      fontSize: '14px',
      lineHeight: '24px',
      overflow: 'hidden',
      padding: '4px 12px',
      position: 'relative',
      textOverflow: 'ellipsis',
      fontWeight: 'normal',
      '&:hover': {
        backgroundColor: '#ecf8f7',
      },
    },
    defaultColor: { color: '#4c4c4c' },
    activeSelected: {
      color: theme.colors.mainGreen6,
      fontWeight: 500,
    },

    optionIcon: {
      color: '#38b2a6',
      position: 'absolute',
      left: '264px',
      top: '50%',
      transform: 'translateY(-50%)',
    },

    clear: {
      padding: '12px',
      ...theme.flex.mainSpaceBetween,
      '& button': {
        background: 'transparent',
        border: '0',
        color: theme.colors.mainGreen6,
        cursor: 'pointer',
        fontSize: '12px',
        lineHeight: '22px',
        margin: 0,
        outline: 'none',
        padding: 0,
        textTransform: 'capitalize',
      },
    },
    showBox: {
      display: 'block',
    },
    loading: {
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%)',
      paddingTop: '10px',
    },
  }),
  { name: 'async-search-select' },
);
